import styles from './popupAnnouncement.module.scss';
import {Card, Descriptions} from 'antd';
import {usePopupAnnouncementStore} from '../../../zustand/store';
import {useCallback} from 'react';
import {useMutation} from '@apollo/client';
import {CREATE_POPUP_ANNOUNCEMENT} from 'graphql/mutations/announcement';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';
import moment from 'moment';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {extractUserIds} from '../actions';

export const StepFourPopupAnnouncement = () => {
  const {popupAnnouncement, setStep, clearPopupAnnouncement} =
    usePopupAnnouncementStore();
  const navigate = useNavigate();

  const [createAnnouncement, {loading: creating}] = useMutation(
    CREATE_POPUP_ANNOUNCEMENT,
    {
      onError: error => toast.error(error.message),
      errorPolicy: 'all',
    },
  );

  const handleSubmit = () => {
    const {
      announcements,
      signupStartDate,
      signupEndDate,
      publishedDate,
      lastAppVisitedStartDate,
      lastAppVisitedEndDate,
      expiredDate,
      investmentStartDate,
      investmentEndDate,
      type,
      report,
      opportunity,
      instrumentId,
      collection,
      userSegments,
      riskProfiles,
      identityCheck,
      documentCheck,
      amlCheck,
      countriesOfInterest,
      countryCodes,
      directions,
      statuses,
      instrumentKeys,
      audienceInstrumentId,
      stockId,
      ventureAssetId,
      userIds,
      ...rest
    } = popupAnnouncement;

    const instrumentIds = [
      audienceInstrumentId,
      stockId,
      ventureAssetId,
    ].filter(Boolean);
    try {
      let announcementData = {};
      switch (type) {
        case 'EVENT':
          announcementData = {
            announcements: announcements.map(announcement => ({
              imageUrl: announcement?.imageUrl,
              actionButtonLabel: announcement?.actionButtonText,
              title: announcement?.title,
              subTitle: announcement?.subTitle,
              announcementUrl: announcement?.announcementUrl,
              popupConfig: {
                dismissible: announcement?.dismissible ?? false,
                maxShowCount: announcement?.maxShowCount ?? 1,
              },
              ...(announcement?.multilang && {
                multiLang: [
                  {
                    imageUrl: announcement?.multilang?.imageUrl,
                    actionButtonLabel:
                      announcement?.multilang?.actionButtonText,
                    language: announcement?.translation,
                    title: announcement?.multilang?.title,
                    subTitle: announcement?.multilang?.subTitle,
                    announcementUrl: announcement?.multilang?.announcementUrl,
                  },
                ],
              }),
            })),
          };
          break;
        case 'GENERAL':
        case 'SIMULATOR':
          announcementData = {
            announcements: announcements.map(announcement => ({
              imageUrl: announcement?.imageUrl,
              actionButtonLabel: announcement?.actionButtonText,
              title: announcement?.title,
              subTitle: announcement?.subTitle,
              announcementUrl: announcement?.announcementUrl,
              popupConfig: {
                dismissible: announcement?.dismissible ?? false,
                maxShowCount: announcement?.maxShowCount ?? 1,
              },
              ...(announcement?.multilang && {
                multiLang: [
                  {
                    announcementUrl: announcement?.multilang?.announcementUrl,
                    actionButtonLabel:
                      announcement?.multilang?.actionButtonText,
                    language: announcement?.translation,
                    title: announcement?.multilang?.title,
                    subTitle: announcement?.multilang?.subTitle,
                    imageUrl: announcement?.multilang?.imageUrl,
                  },
                ],
              }),
            })),
          };
          break;
        case 'AUDIO':
          announcementData = {
            announcements: announcements.map(announcement => ({
              audioUrl: announcement?.audioFile,
              actionButtonLabel: announcement?.actionButtonText,
              title: announcement?.title,
              subTitle: announcement?.subTitle,
              imageUrl: announcement?.imageUrl,
              announcementUrl: announcement?.announcementUrl,
              popupConfig: {
                dismissible: announcement?.dismissible ?? false,
                maxShowCount: announcement?.maxShowCount ?? 1,
              },
              ...(announcement?.multilang && {
                multiLang: [
                  {
                    audioUrl: announcement?.multilang?.audioFile,
                    actionButtonLabel:
                      announcement?.multilang?.actionButtonText,
                    language: announcement?.translation,
                    title: announcement?.multilang?.title,
                    subTitle: announcement?.multilang?.subTitle,
                    imageUrl: announcement?.multilang?.imageUrl,
                    announcementUrl: announcement?.multilang?.announcementUrl,
                  },
                ],
              }),
            })),
          };
          break;
        case 'VIDEO':
          announcementData = {
            announcements: announcements.map(announcement => ({
              announcementUrl: announcement?.videoUrl,
              actionButtonLabel: announcement?.actionButtonText,
              imageUrl: announcement?.imageUrl,
              title: announcement?.title,
              subTitle: announcement?.subTitle,
              popupConfig: {
                dismissible: announcement?.dismissible ?? false,
                maxShowCount: announcement?.maxShowCount ?? 1,
              },
              ...(announcement?.multilang && {
                multiLang: [
                  {
                    announcementUrl: announcement?.multilang?.videoUrl,
                    actionButtonLabel:
                      announcement?.multilang?.actionButtonText,
                    title: announcement?.multilang?.title,
                    subTitle: announcement?.multilang?.subTitle,
                    language: announcement?.translation,
                    imageUrl: announcement?.multilang?.imageUrl,
                  },
                ],
              }),
            })),
          };
          break;
        case 'REPORT':
          announcementData = {
            announcements: announcements.map(announcement => ({
              actionButtonLabel: announcement?.actionButtonText,
              imageUrl: announcement?.imageUrl,
              title: announcement?.title,
              subTitle: announcement?.subTitle,
              popupConfig: {
                dismissible: announcement?.dismissible ?? false,
                maxShowCount: announcement?.maxShowCount ?? 1,
              },
              ...(announcement?.multilang && {
                multiLang: [
                  {
                    imageUrl: announcement?.multilang?.imageUrl,
                    actionButtonLabel:
                      announcement?.multilang?.actionButtonText,
                    language: announcement?.translation,
                    title: announcement?.multilang?.title,
                    subTitle: announcement?.multilang?.subTitle,
                  },
                ],
              }),
            })),
          };
          break;
        case 'OPPORTUNITY_LISTING':
          announcementData = {
            announcements: announcements.map(announcement => ({
              actionButtonLabel: announcement?.actionButtonText,
              imageUrl: announcement?.imageUrl,
              title: announcement?.title,
              subTitle: announcement?.subTitle,
              popupConfig: {
                dismissible: announcement?.dismissible ?? false,
                maxShowCount: announcement?.maxShowCount ?? 1,
              },
              ...(announcement?.multilang && {
                multiLang: [
                  {
                    actionButtonLabel:
                      announcement?.multilang?.actionButtonText,
                    language: announcement?.translation,
                    title: announcement?.multilang?.title,
                    subTitle: announcement?.multilang?.subTitle,
                    imageUrl: announcement?.multilang?.imageUrl,
                  },
                ],
              }),
            })),
          };
          break;
        default:
          announcementData = {
            announcements: announcements.map(announcement => ({
              actionButtonLabel: announcement?.actionButtonText,
              imageUrl: announcement?.imageUrl,
              title: announcement?.title,
              subTitle: announcement?.subTitle,
              popupConfig: {
                dismissible: announcement?.dismissible ?? false,
                maxShowCount: announcement?.maxShowCount ?? 1,
              },
              ...(announcement?.multilang && {
                multiLang: [
                  {
                    actionButtonLabel:
                      announcement?.multilang?.actionButtonText,
                    language: announcement?.translation,
                    title: announcement?.multilang?.title,
                    subTitle: announcement?.multilang?.subTitle,
                    imageUrl: announcement?.multilang?.imageUrl,
                  },
                ],
              }),
            })),
          };
          break;
      }
      const variables = {
        ...rest,
        type,
        displayType: 'POPUP',
        ...(type === 'SINGLE_REPORT' && {report}),
        // Instrument v2: every instrument destination is `instrumentId`.
        // `company` (stock) and `instrument` (bond/fund) are deprecated and
        // rejected at runtime on dev. IPO, startup and venture fund ride on
        // SINGLE_OPPORTUNITY with the same field.
        //
        // SINGLE_OPPORTUNITY accepts exactly one of the two, so a legacy
        // campaign id is only sent when there is no instrument.
        ...(instrumentId
          ? {instrumentId}
          : type === 'SINGLE_OPPORTUNITY' && opportunity
          ? {opportunity}
          : {}),
        ...(type === 'SINGLE_COLLECTION' && {collection}),
        announcements: announcementData.announcements,
        expiredDate: moment(expiredDate).format(),
        publishedDate: moment(publishedDate).format(),
        targetAudience: {
          lastAppVisit: {
            ...(lastAppVisitedStartDate && {
              start: moment(lastAppVisitedStartDate).format(),
            }),
            ...(lastAppVisitedEndDate && {
              end: moment(lastAppVisitedEndDate).format(),
            }),
          },
          userSegments,
          riskProfiles,
          countryCodes,
          ...(userIds?.length && {userIds: extractUserIds(userIds)}),
          kycStatus: {
            identityCheck,
            documentCheck,
            amlCheck,
          },
          countriesOfInterest,
          signUpTime: {
            ...(signupStartDate && {
              start: moment(signupStartDate).format(),
            }),
            ...(signupEndDate && {
              end: moment(signupEndDate).format(),
            }),
          },
          transaction: {
            directions,
            statuses,
            ...(investmentStartDate && {
              startDate: moment(investmentStartDate).format(),
            }),
            ...(investmentEndDate && {
              endDate: moment(investmentEndDate).format(),
            }),
            instrumentKeys,
            instrumentIds,
          },
        },
      };

      createAnnouncement({
        variables: {
          data: variables,
        },
      })
        .then(({data: {createBulkAnnouncements}}) => {
          if (createBulkAnnouncements.__typename === 'Error') {
            toast.error(createBulkAnnouncements.message);
          } else {
            toast.success('Popup announcement created successfully!');
            setStep(0);
            clearPopupAnnouncement();
            navigate('/dashboard/announcements');
          }
        })
        .catch(error => {
          toast.error(error.message);
        });
    } catch (error) {
      toast.error('Failed to create popup announcement');
      console.error('Error creating announcement:', error);
    }
  };

  const handleBack = useCallback(() => {
    setStep(2);
  }, [setStep]);

  return (
    <div className={styles.stepFourContainer}>
      <h2>Review & Create</h2>
      <p>Please review your popup announcement details before creating</p>

      <Card title="Announcement Summary" className={styles.summaryCard}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Language">
            {popupAnnouncement.language}
          </Descriptions.Item>
          <Descriptions.Item label="Type">
            {popupAnnouncement.type}
          </Descriptions.Item>
          <Descriptions.Item label="Published Date">
            {popupAnnouncement.publishedDate?.format?.(
              'DD MMM, YYYY hh:mm a',
            ) || popupAnnouncement.publishedDate}
          </Descriptions.Item>
          <Descriptions.Item label="Expiry Date">
            {popupAnnouncement.expiredDate?.format?.('DD MMM, YYYY hh:mm a') ||
              popupAnnouncement.expiredDate}
          </Descriptions.Item>
          <Descriptions.Item label="Number of Announcements">
            {popupAnnouncement.announcements?.length}
          </Descriptions.Item>
          {popupAnnouncement.userSegments?.length > 0 && (
            <Descriptions.Item label="User Segments">
              {popupAnnouncement.userSegments
                .map(segment => segment?.replaceAll('_', ' ')?.toLowerCase())
                ?.join(', ')}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Card>

      <div className={styles.actionButtons}>
        <SubmitButton
          type="button"
          handleClick={handleBack}
          size="large"
          label="Back"
        />
        <SubmitButton
          handleClick={handleSubmit}
          secondary
          label="Create Announcement"
          disabled={creating}
        />
      </div>
    </div>
  );
};
